module.exports = __webpack_public_path__ + "img/file-history.f7bb1682.svg";